import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import TopApps from './components/TopApps';
import AppList from './components/AppList';
import LatestAppsList from './components/LatestAppsList';
import InfoSection from './components/InfoSection';
import HindiInfoSection from './components/HindiInfoSection';
import Footer from './components/Footer';
import AppDetail from './pages/AppDetail';
import Seo from './components/Seo';
import ScrollToTop from './components/ScrollToTop';
import { Toaster } from './components/ui/toaster';
import { SiteProvider, useSite } from './context/SiteContext';
import { Loader2 } from 'lucide-react';

// Admin
import AdminLayout from './pages/admin/AdminLayout';
import AdminLogin from './pages/admin/AdminLogin';
import Dashboard from './pages/admin/Dashboard';
import AppsList from './pages/admin/AppsList';
import AppEdit from './pages/admin/AppEdit';
import SettingsPage from './pages/admin/SettingsPage';

const Home = () => {
  const { settings, loading } = useSite();
  const homeJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: settings?.siteTitle || 'GoGoYonoGames',
    url: 'https://gogoyonogames.com/',
  };
  return (
    <div className="min-h-screen bg-white">
      <Seo
        title={settings?.metaTitle || 'GoGoYonoGames - Top Yono Earning & Rummy Apps Download 2025'}
        description={settings?.metaDescription || 'Download the best Yono earning apps and rummy games on GoGoYonoGames.'}
        keywords={settings?.metaKeywords || 'gogoyonogames, yono earning app'}
        jsonLd={homeJsonLd}
      />
      <Header />
      <main>
        {loading ? (
          <div className="p-16 text-center text-gray-500">
            <Loader2 className="w-6 h-6 animate-spin inline" />
          </div>
        ) : (
          <>
            <TopApps />
            <AppList />
            <LatestAppsList />
            <HindiInfoSection />
            <InfoSection />
          </>
        )}
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <SiteProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/app/:slug" element={<AppDetail />} />

            {/* Admin */}
            <Route path="/wp-admin/login" element={<AdminLogin />} />
            <Route path="/wp-admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="apps" element={<AppsList />} />
              <Route path="apps/new" element={<AppEdit />} />
              <Route path="apps/:id/edit" element={<AppEdit />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
          </Routes>
        </SiteProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
